module.exports = "<div type=\"text\" id=\"quantity-filter\"></div>\n<span id=\"slider-indicator\">1 - 33</span>"


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/_components/quantity-filter/quantity-filter.component.html
// module id = ../../../../../src/app/_components/quantity-filter/quantity-filter.component.html
// module chunks = main